import api from './api'
import type { ExclusionItem } from '@/types'

export const exclusionsService = {
  async listByType(type: 'exclusion' | 'inclusion') {
    const { data } = await api.get(`/exclusions?type=${type}`)
    return data.data as ExclusionItem[]
  },

  async create(type: 'exclusion' | 'inclusion', text: string) {
    const { data } = await api.post('/exclusions', { type, text })
    return data.data as ExclusionItem
  },

  async update(id: string, text: string) {
    const { data } = await api.put(`/exclusions/${id}`, { text })
    return data.data as ExclusionItem
  },

  async remove(id: string) {
    await api.delete(`/exclusions/${id}`)
  },

  async reorder(ids: string[]) {
    const { data } = await api.post('/exclusions/reorder', { ids })
    return data.data as ExclusionItem[]
  },
}
